export { default } from './Panel';



// WEBPACK FOOTER //
// ./app/components/shared/Panel/index.js